import $ from "jquery";
import Transition from "./transition";
import lurl from "./lurl";
export class Dialog {
    constructor(selector, options = {}) {
        this.selector = selector;
        this.options = options || {};
        this.options.onOpen = this.options.onOpen || function () { };
        this.options.onSubmit = this.options.onSubmit || function () { };
        this.options.onCancel = this.options.onCancel || function () { };
        this.$.find("a.close").click(e => this.cancel());
        this.$.find("form").submit(e => {
            this.submit();
            return false;
        });
    }
    get $() {
        return $(this.selector);
    }
    show() {
        this.$.css("display", "");
        this.center();
        this.options.onOpen(this);
    }
    hide() {
        this.$.css("display", "none");
    }
    isVisible() {
        return this.$.css("display") != "none";
    }
    cancel() {
        this.options.onCancel(this);
        this.hide();
    }
    submit() {
        this.$.find("input").blur();
        if (this.options.onSubmit(this) !== false) {
            this.hide();
        }
    }
    center() {
        const e = this.$.get(0);
        const x = Math.round(window.innerWidth / 2 - e.offsetWidth / 2);
        let y = Math.round((window.innerHeight / 2 - e.offsetHeight / 2) * 0.8);
        if (y < 12) {
            y = 12;
        }
        this.$.css("left", `${x}px`);
        this.$.css("top", `${y}px`);
    }
}
export class GameOverDialog extends Dialog {
    show() {
        super.show();
        this.$.find(".scores").load(lurl("/users/timed_leader_board"), () => this.center());
    }
    // unlike setting the values directly, this will transition
    // the values up in a cool looking way
    setScoreAndTime(score, ms) {
        Transition.number({ duration: 800 }, n => {
            this.score = Math.round(score * n);
            this.ms = Math.round(ms * n);
        });
    }
    set score(v) {
        this._score = v;
        $(".section.header .score").text(v);
    }
    set ms(v) {
        this._ms = v;
        $(".section.header .time").text(this.msToText(this._ms));
    }
    msToText(ms) {
        const seconds = Math.floor(Math.abs(ms) / 1000);
        const minutes = Math.floor(seconds / 60);
        return `${this._pad(minutes)}:${this._pad(seconds % 60)}`;
    }
    _pad(n) {
        return n < 10 ? "0" + n.toString() : n.toString();
    }
}
export class StartDialog extends Dialog {
    show() {
        super.show();
        $(".dialog.leaders .content").load(lurl("/users/leader_board"), () => {
            new TabSet(".tabs");
            this.center();
        });
    }
}
export class BuyDialog extends Dialog {
    constructor(selector, options) {
        super(selector, options);
        this.socket = this.options.socket;
        this._isLoading = false;
        this._data = null;
        this.$.find("input.cancel").click(() => this.hide());
    }
    submit() {
        if (this.isLoading) {
            return;
        }
        this.isLoading = true;
        this.socket
            .send("buy_item", { code: this.itemCode, data: this._data })
            .then(response => {
            if (this.options.onPurchaseComplete) {
                this.options.onPurchaseComplete(response, this);
            }
        });
        return false;
    }
    show() {
        super.show();
        const el = $(".header .cr");
        el.text("...");
        this.socket.send("whoami", {}).then(me => {
            $(".header .cr").text(`${me.credit}CR`);
        });
    }
    get itemCode() {
        return this.$.attr("data-item");
    }
    get cost() {
        return parseInt(this.$.attr("data-cost"), 10);
    }
    get isLoading() {
        return this._isLoading;
    }
    set isLoading(v) {
        this._isLoading = !!v;
        if (this._isLoading) {
            this.$.find("input[type=submit]").val("loading...");
        }
        else {
            this.$.find("input[type=submit]").val("yep!");
        }
    }
}
export class BuyLetterDialog extends BuyDialog {
    constructor(selector, options) {
        super(selector, options);
        this.selectedLetter = "a";
        $(".dialog.buy.letter .tile-select").click(e => {
            this.selectedLetter = $(e.target).text();
        });
    }
    submit() {
        this._data = this.selectedLetter;
        return super.submit();
    }
    set selectedLetter(v) {
        const el = $(`.tile-select.l-${v.toLowerCase()}`);
        if (el) {
            const letter = el.text();
            this.$.find(".tile-select").removeClass("selected");
            el.addClass("selected");
            this.$.find("input[type=submit]").val(`get '${letter}' for ${this.cost}CR`);
        }
    }
    get selectedLetter() {
        return this.$.find(".tile-select.selected").text();
    }
}
class TabSet {
    constructor(selector) {
        this.selector = selector;
        this.$.find("span").click(e => {
            const tabSel = $(e.target).attr("data-tab");
            this.$.find("span").removeClass("selected");
            $(e.target).addClass("selected");
            $(".tab-content").hide();
            $(tabSel).show();
        });
        $(".tab-content").hide();
        $(".tab-content.daily").show();
    }
    get $() {
        return $(this.selector);
    }
}
